import {PageTitle} from '../../_metronic/layout/core'
import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {actionGetCurriculums} from '../../redux/education'
import {ICurriculum, IStory, reduxProps} from '../../constants'
import {actionStoryDetailModalOpen} from '../../redux/modal'
import {CurriculumLibraries} from './CurriculumLibraries'

export function Curriculum() {
  const [curriculums, setCurriculums] = useState<ICurriculum[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [retry, setRetry] = useState(0)
  const {stories, classroom} = useSelector((state: reduxProps) => state.educationReducer)
  const {staffInfo} = useSelector((state: reduxProps) => state.authReducer)
  const dispatch = useDispatch()

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(false)
    dispatch(
      actionGetCurriculums({languageCode: 'tr-TR', createdUserId: staffInfo.id}, (result) => {
        if (cancelled) return
        if (result.type === 'SUCCESS') setCurriculums(result.payload.data || [])
        else setError(true)
        setLoading(false)
      })
    )
    return () => {
      cancelled = true
    }
  }, [dispatch, staffInfo.id, retry])

  function openStory(item: IStory) {
    dispatch(
      actionStoryDetailModalOpen({
        StoryId: item.storyId,
        StoryDetailId: item.storyDetailId,
        LanguageCode: item.languageCode,
      })
    )
  }
  return (
    <div>
      <PageTitle description='Okul öncesinden başlayarak sınıf düzeylerine göre kitaplıkları keşfedin ve kitapları inceleyin.'>
        Kitaplıklarım
      </PageTitle>
      <CurriculumLibraries
        curriculums={curriculums}
        stories={stories || []}
        activeCurriculumId={classroom?.curriculumId}
        loading={loading}
        error={error}
        onRetry={() => setRetry((value) => value + 1)}
        onOpenStory={openStory}
      />
    </div>
  )
}
